module.exports = __webpack_public_path__ + "media/src/img/payment/o-nas-1-3973f5b1567afcbe8a9ea5b00e693e14.jpg";